import { styled } from "@mui/material/styles";
import Slider from "@mui/material/Slider";
import { TextField } from "@mui/material";
import { onlyNumberRegex } from "services/constants/patterns";
import * as Mui from "@mui/material";
import React from "react";

export const CustomSlider = styled(Slider)(
  ({ theme, slidercolor = "#14B8A6" }) => ({
    color: slidercolor,
    height: 6,
    padding: "15px 0",
    "& .MuiSlider-thumb": {
      height: 20,
      width: 20,
      backgroundColor: slidercolor,
      border: "3px solid #fff",
      "&:hover": {
        boxShadow: `0 0 0 8px ${slidercolor}33`, // translucent hover
      },
      "&.Mui-focusVisible": {
        boxShadow: `0 0 0 8px ${slidercolor}55`, // focus ring
      },
    },
    "& .MuiSlider-track": {
      border: "none",
      backgroundColor: slidercolor,
    },
    "& .MuiSlider-rail": {
      backgroundColor: "#E5E7EB",
      opacity: 1,
    },
    "& .MuiSlider-valueLabel": {
      backgroundColor: slidercolor,
      borderRadius: "6px",
      fontSize: 12,
      padding: "2px 6px",
    },
  })
);

export const CustomInputBox = ({
  name,
  value,
  register,
  errors,
  handlePolicyChange,
  rules,
  maxLength = 3,
  inputWidth,
}) => {
  return (
    <TextField
      size="small"
      value={value}
      inputProps={{
        style: {
          textAlign: "center",
          width: inputWidth ?? "25px",
          height: "16px",
        },
      }}
      {...register(name, rules)}
      onChange={(event) => {
        if (
          onlyNumberRegex.test(event.target.value) &&
          event.target.value.length <= maxLength
        ) {
          handlePolicyChange(name, event.target.value);
        }
      }}
      error={Boolean(errors[name])}
      helperText={errors[name]?.message || ""}
    />
  );
};

export const CompanyProgress = ({ comLogo, themes }) => {
  return (
    <Mui.Grid container justifyContent="center">
      <Mui.Box
        sx={{
          position: "relative",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          width: 100,
          height: 100,
        }}
      >
        <Mui.CircularProgress
          size={70}
          thickness={2}
          sx={{ color: themes.primaryIndicator }}
        />
        <Mui.Box
          sx={{
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: 40,
            height: 40,
          }}
        >
          <img
            src={comLogo}
            alt="Company Logo"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Mui.Box>
      </Mui.Box>
    </Mui.Grid>
  );
};
